<template>
  <el-dialog width="70%" title="表单自定义字段设置" :visible="dialogVisible" :close-on-click-modal="false" append-to-body top="8vh" :before-close="handleClose">
    <vxe-toolbar>
      <template #buttons>
        <el-button type="primary" size="small" @click="insertEvent(-1)">添加</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      resizable
      show-overflow
      keep-source
      ref="xTable"
      max-height="600"
      :data="schema"
      :edit-rules="formRules"
      :sort-config="{ trigger: 'cell' }"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
    >
      <vxe-column field="label" title="字段名称">
        <template #default="{ row }">
          <vxe-input v-model="row.label" type="text"></vxe-input>
        </template>
      </vxe-column>
      <vxe-column field="type" title="字段类型">
        <template #default="{ row }">
          <el-select v-model="row.type">
            <el-option v-for="item in expandFieldTypes" :key="item.code" :value="item.code" :label="item.name"></el-option>
          </el-select>
        </template>
      </vxe-column>
      <!-- 是否必填 -->
      <vxe-column field="required" title="验证规则" show-overflow>
        <template #default="{ row }">
          <el-select v-model="row.config.validators" multiple>
            <el-option v-for="item in validators" :key="item.code" :value="item.code" :label="item.name"></el-option>
          </el-select>
        </template>
      </vxe-column>
      <vxe-column title="操作" width="160" show-overflow>
        <template #default="{ row, index }">
          <vxe-button @click="editEvent(row)">编辑</vxe-button>
          <vxe-button @click="removeEvent(row, index)">删除</vxe-button>
        </template>
      </vxe-column>
    </vxe-table>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="saveEvent">提交</el-button>
    </div>
    <!--新增编辑表单-->
    <vxe-modal
      v-model="showEdit"
      :title="selectRow ? '编辑&保存' : '新增&保存'"
      width="600"
      min-width="400"
      min-height="300"
      resize
      destroy-on-close
      @close="closeDialog"
    >
      <template #default>
        <vxe-form ref="configForm" :data="formData" :rules="formRules" title-align="right" title-width="100" @submit="submitEvent">
          <vxe-form-item field="label" title="字段名称" :span="24" :item-render="{}">
            <template #default="{ data }">
              <vxe-input v-model="data.label" placeholder="请输入名称"></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item field="type" title="字段类型" :span="24" :item-render="{}">
            <template #default="{ data }">
              <el-select ref="fieldType" v-model="data.type" placeholder="请选择" transfer @change="typeChange(data)">
                <el-option v-for="item in expandFieldTypes" :key="item.code" :value="item.code" :label="item.name"></el-option>
              </el-select>
            </template>
          </vxe-form-item>
          <vxe-form-item field="config.validators" title="字段验证" :span="24" :item-render="{}">
            <template #default="{ data }">
              <el-select ref="validator" v-model="data.config.validators" placeholder="请选择" transfer multiple>
                <el-option v-for="item in validators" :key="item.code" :value="item.code" :label="item.name"></el-option>
              </el-select>
            </template>
          </vxe-form-item>
          <vxe-form-item field="config.format" title="格式化" :span="24" :item-render="{}" :visible="formData.type === 'number' || formData.type === 'date'">
            <template #default="{ data }">
              <el-select v-model="data.config.format" placeholder="请选择" transfer>
                <el-option
                  v-for="item in formData.type === 'number' ? formatNumber : formatDate"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                ></el-option>
              </el-select>
            </template>
          </vxe-form-item>
          <vxe-form-item field="config.precision" title="精度" :span="24" :item-render="{}" :visible="formData.type === 'number'">
            <template #default="{ data }">
              <vxe-input v-model="data.config.precision" :min="0" type="integer" placeholder="请输入精度"></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item field="config.min" title="最小值" :span="24" :item-render="{}" :visible="formData.type === 'number'">
            <template #default="{ data }">
              <vxe-input v-model="data.config.min" :min="minVal" :max="maxVal" type="integer" placeholder="请输入最小值"></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item
            field="config.max"
            title="最大值"
            :span="24"
            :item-render="{}"
            :visible="formData.type === 'number' || formData.type === 'input' || formData.type === 'textarea'"
          >
            <template #default="{ data }">
              <vxe-input v-model="data.config.max" :min="minVal" :max="maxVal" type="integer" placeholder="请输入最大值"></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item
            field="config.type"
            title="选项类型"
            :span="24"
            :item-render="{}"
            :visible="formData.type === 'switch' || formData.type === 'radio' || formData.type === 'select'"
            @change="typeChange(data)"
          >
            <template #default="{ data }">
              <el-select v-model="data.config.type" placeholder="请选择" transfer @change="selectTypeChange(data)">
                <el-option v-for="item in selectType" :key="item.code" :value="item.code" :label="item.name"></el-option>
              </el-select>
            </template>
          </vxe-form-item>
          <vxe-form-item field="config.key" title="动态选项" :span="24" :item-render="{}" :visible="formData.config.type === 'dict'">
            <template #default="{ data }">
              <el-select v-model="data.config.key" placeholder="请选择" transfer filterable clearable>
                <el-option v-for="item in dicData" :key="item.typeKey" :value="item.typeKey" :label="item.text"></el-option>
              </el-select>
            </template>
          </vxe-form-item>
          <vxe-form-item field="config.option" title="自定义选项" :span="24" :item-render="{}" :visible="formData.config.type === 'custom'">
            <template #default="{ data }">
              <table>
                <tr class="linkageTable-tr">
                  <td style="width: 100px">选项值</td>
                  <td>选项标签</td>
                  <td style="width: 100px; text-align: center">操作</td>
                </tr>
                <tr v-for="(item, index) in data.config.option" :key="index">
                  <td>
                    <el-input size="mini" v-model="item.value" maxlength="20" placeholder="选项值"></el-input>
                  </td>
                  <td>
                    <el-input size="mini" v-model="item.label" maxlength="20" placeholder="选项标签"></el-input>
                  </td>
                  <td style="text-align: center">
                    <el-button class="btn-padding" size="mini" icon="el-icon-plus" @click="data.config.option.push({ key: '', value: '' })"></el-button>
                    <el-button
                      class="btn-padding"
                      size="mini"
                      style="margin-left: 5px"
                      icon="el-icon-delete"
                      v-if="data.config.option.length > 1"
                      @click="data.config.option.remove(item)"
                    ></el-button>
                  </td>
                </tr>
              </table>
            </template>
          </vxe-form-item>
          <!--操作按钮-->
          <vxe-form-item align="center" title-align="left" :span="24">
            <template #default>
              <vxe-button type="submit" status="primary">保存</vxe-button>
              <vxe-button type="reset">重置</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </template>
    </vxe-modal>
  </el-dialog>
</template>

<script>
import VXETable from 'vxe-table'
import form from '@/api/form'
import * as constants from './constants'

export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      drawerSize: '90%',
      submitLoading: false,
      pageBean: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      height: '100%',
      configId: null,
      formId: null,
      formKey: null,
      formName: null,
      formVersion: null,
      formStatus: null,
      schema: [],
      dicData: [],
      formData: {
        label: null,
        type: null,
        enabled: true,
        config: {
          validators: null,
          format: null,
          precision: null,
          min: null,
          max: null,
          type: null,
          key: null,
          option: null
        }
      },
      minVal: 0,
      maxVal: 9999999999,
      formRules: {
        label: [
          { required: true, message: '名称必须填写' },
          { min: 0, max: 15, message: '长度在 0 到 15 个字符' }
        ],
        type: [{ required: true, message: '字段类型必须填写' }]
      },
      selectRow: null,
      showEdit: false,
      tenantId: '',
      ...constants
    }
  },
  mounted() {
    this.tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
    this.height = this.tenantId && this.tenantId != -1 ? 'calc(100% - 56px)' : '100%'
    this.getAllDict()
  },
  methods: {
    async showDialog(param) {
      this.formStatus = 'enable'
      this.schema = param
      this.dialogVisible = true
    },
    async insertEvent() {
      this.showEdit = true
      this.selectRow = null
      Object.assign(this.formData, {
        id: null,
        label: null,
        type: null,
        enabled: true,
        config_id: this.configId,
        config: {
          validators: null,
          format: null,
          precision: null,
          min: null,
          max: null,
          type: null,
          key: null,
          option: null
        }
      })
    },
    editEvent(row) {
      this.selectRow = row
      this.showEdit = true
      Object.assign(this.formData, this.selectRow)
    },
    async removeEvent(row, index) {
      this.$confirm('您确定要删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        this.$refs.xTable.remove(row)
      })
    },
    submitEvent() {
      const $table = this.$refs.xTable
      this.$refs.configForm.validate((valid) => {
        if (!valid) {
          //表单验证
          this.showEdit = false
          if (this.selectRow) {
            Object.assign(this.selectRow, this.formData)
          } else {
            $table.insertAt(this.formData, -1)
          }
        }
      })
    },
    closeDialog() {
      this.showEdit = false
    },
    typeChange(data) {
      this.minVal = -999999999
      this.maxVal = 999999999
      if (data.type === 'input') {
        this.minVal = 0
        this.maxVal = 9999999999
      } else if (data.type === 'textarea') {
        this.minVal = 0
        this.maxVal = 3000
      }
      // 验证规则
      this.changeRules()
      Object.assign(this.formData, {
        label: data.label,
        type: data.type,
        enabled: true,
        config: {
          validators: null,
          format: null,
          precision: null,
          min: null,
          max: null,
          type: null,
          key: null,
          option: null
        }
      })
    },
    selectTypeChange(data) {
      Object.assign(this.formData, {
        label: data.label,
        type: data.type,
        enabled: true,
        config: {
          validators: data.config.validators,
          format: null,
          precision: null,
          min: null,
          max: null,
          type: data.config.type,
          key: null,
          option: data.config.type === 'dict' ? null : [{ key: '', value: '' }]
        }
      })
    },
    changeRules() {
      this.formRules['config.format'] = []
      this.formRules['config.precision'] = []
      this.formRules['config.min'] = []
      this.formRules['config.max'] = []
      this.formRules['config.type'] = []
      this.formRules['config.key'] = []
      this.formRules['config.option'] = []
      if (this.formData.type === 'input' || this.formData.type === 'textarea') {
        this.formRules['config.max'] = [{ required: true, message: '最大值必须填写' }]
      } else if (this.formData.type === 'number') {
        this.formRules['config.format'] = [{ required: true, message: '格式化必须填写' }]
        this.formRules['config.precision'] = [{ required: true, message: '格式化必须填写' }]
        this.formRules['config.min'] = [{ required: true, message: '最小值必须填写' }]
        this.formRules['config.max'] = [{ required: true, message: '最大值必须填写' }]
      } else if (this.formData.type === 'date') {
        this.formRules['config.format'] = [{ required: true, message: '格式化必须填写' }]
      } else if (this.formData.type === 'radio' || this.formData.type === 'select') {
        this.formRules['config.type'] = [{ required: true, message: '选项类型必须填写' }]
        if (this.formData.config.type === 'dict') {
          this.formRules['config.key'] = [{ required: true, message: '动态选项必须填写' }]
        } else if (this.formData.config.type === 'custom') {
          this.formRules['config.option'] = [{ required: true, message: '自定义选项必须填写' }]
        }
      }
    },
    // 获取数据字典
    getAllDict() {
      form.getCategory('DIC', (data) => {
        this.dicData = data.data
      })
    },
    // 提交操作
    async saveEvent() {
      const $table = this.$refs.xTable
      const errMap = await $table.validate().catch((errMap) => errMap)
      if (errMap) return
      this.loading = true
      try {
        this.schema = $table.getTableData().tableData
        this.$emit('saveSchema', this.schema)
        this.dialogVisible = false
      } catch (e) {
        if (e && e.message) {
          VXETable.modal.message({ content: e.message, status: 'error' })
        }
      } finally {
        this.loading = false
      }
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>
<style scoped>
.demo-drawer__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
}
</style>
